module.exports = __webpack_public_path__ + "img/Dominican Republic.b7a28392.svg";